export default "__VITE_ASSET__C332R5H8__"